import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { defineComponent, defineProps } from 'vue'

const __default__ = defineComponent({
  name: "AppointmentsAcessCodesTableRow"
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['appointmentsAccessCodeData'],
  setup(__props) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, _toDisplayString(__props.appointmentsAccessCodeData.valid_from), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentsAccessCodeData.valid_to), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentsAccessCodeData.code), 1)
    ]),
    _createElementVNode("td", null, _toDisplayString(__props.appointmentsAccessCodeData.included_appointments ? _ctx.$t('AppointmentsAccessCodesData.Free') : _ctx.$t('AppointmentsAccessCodesData.Normal')), 1)
  ], 64))
}
}

})